export default __webpack_public_path__ + "static/media/no-content.18b7f80a.svg";